import { TaskTypeDefinition } from "./quadriRestApi"
import QuadriRestApi from "./quadriRestApi"

export class TaskTypeDefinitionsCache {
  private static _instance: TaskTypeDefinitionsCache
  private _taskTypeDefinitions: Map<string, TaskTypeDefinition>

  private constructor() {
    this._taskTypeDefinitions = new Map<string, TaskTypeDefinition>()
  }

  public static getInstance(): TaskTypeDefinitionsCache {
    if (!TaskTypeDefinitionsCache._instance) {
      TaskTypeDefinitionsCache._instance = new TaskTypeDefinitionsCache()
    }
    return TaskTypeDefinitionsCache._instance
  }

  public async init(accessToken: string, projectLocation: string): Promise<void> {
    if (this._taskTypeDefinitions.size > 0) {
      return Promise.resolve()
    }

    const restApi = new QuadriRestApi()
    await restApi.initialize(accessToken, projectLocation)

    const taskTypeSchemas = await restApi.getTaskSchemas()
    TaskTypeDefinitionsCache.getInstance().buildCache(taskTypeSchemas)
    return Promise.resolve()
  }

  private buildCache(taskTypeDefinitions: TaskTypeDefinition[]): void {
    taskTypeDefinitions.forEach((taskTypeDefinition) => {
      this._taskTypeDefinitions.set(taskTypeDefinition.id, taskTypeDefinition)
    })
  }

  public getTaskTypeDefinition(taskTypeTag: string): TaskTypeDefinition | undefined {
    return this._taskTypeDefinitions.get(taskTypeTag)
  }

  public setTaskTypeDefinition(taskTypeTag: string, taskTypeDefinition: TaskTypeDefinition): void {
    this._taskTypeDefinitions.set(taskTypeTag, taskTypeDefinition)
  }
}
